import axios from "axios";
import React, { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";

import { useAuth } from "../../../Auth/Auth";

import AddBoxOutlinedIcon from "@material-ui/icons/AddBoxOutlined";
import { TeacherSchedule } from "../../Table/TableHeaders";
import TableComponent from "../../Table/Table";
import Headerfeatures from "../../Header/Headerfeatures";
import { assignClassSubject } from "../../RenderDetailsData/RenderDetailsData";
import AddModalComponent from "../../Modal/AddModalComponent";
import AssignedSubject from "./AssignedSubject";
import { CommonHeader } from "../../Dashboard/TabComponent/TabComponent.style";
import { Line } from "../../Dashboard/Dashboard.style";

import { schools, subjectTeachers } from "../../../Api/api";
import GradeSorter from "../../../utils/GradeSorter";
import {sortGrades} from "../../../utils/sort";

function TeachersSchedule(props) {
  const [modal, setModal] = useState(false);
  const [label, setLabel] = useState([]);
  const { readCookie, DisplaySnackbar } = useAuth();
  const { schoolId, staffId } = useParams();
  const [grades, setGrades] = useState([]);
  const [sections, setSections] = useState([]);
  const [sectionsId, setSectionsId] = useState([]);
  const [teacherSchedule, setTeacherSchedule] = useState([]);
  const [render, setRender] = useState(false);
  const [formData, setFormData] = useState({
    class: "",
    section: "",
    subject: "",
  });

  function removeSubjectFromSectionState(sectionId, subjectId) {
    const sectionIndex = teacherSchedule.findIndex(
      (section) => section._id === sectionId
    );
    if (sectionIndex !== -1) {
      teacherSchedule[sectionIndex].subjects = teacherSchedule[
        sectionIndex
      ].subjects.filter((subject) => subject._id !== subjectId);
    }
    setTeacherSchedule([...teacherSchedule]);
  }

  useEffect(() => {
    axios
      .get(schools.getClasses(schoolId), {
        headers: {
          token: `${readCookie("token")}`,
        },
      })
      .then((res) => {
        const grades = sortGrades(res.data.data.grades);
        setGrades(grades);
        setLabel(assignClassSubject(grades, [], []));
      })
      .catch((err) => console.log(err));
  }, []);

  useEffect(() => {
    axios
      .get(subjectTeachers.getAssignedSubjects(staffId), {
        headers: {
          token: `${readCookie("token")}`,
        },
      })
      .then((res) => {
        const sortedGrades = new GradeSorter(res.data.data.sections).sort()
        setTeacherSchedule(sortedGrades);
      })
      .catch((err) => console.log(err));
  }, [render]);

  const handleMultiSelect = (type, id) => {
    if (type === "section") {
      if (sectionsId.includes(id)) {
        setSectionsId(sectionsId.filter((item) => item !== id));
      } else {
        setSectionsId([...sectionsId, id]);
      }
    }
  };

  const tabContent = useMemo(() => {
    let arr = [];
    if (teacherSchedule.length) {
      arr = teacherSchedule
        .map((item, index) => {
          const { english_subjects, hindi_subjects } = item.subjects
            .sort((a, b) => a.subject.localeCompare(b.subject))
            .reduce(
              (acc, curr) => {
                if (curr.subjectData?.lang === "english") {
                  acc.english_subjects.push(curr);
                } else {
                  acc.hindi_subjects.push(curr);
                }
                return acc;
              },
              { english_subjects: [], hindi_subjects: [] }
            );

          const info = {
            _info: {
              enabled: item?.sectionId?.enabled || false,
              warnings: [],
            },
          };
          if (!info._info.enabled) {
            info._info.warnings.push(
              `Class ${item._id.split("-")[0]} is disabled. All assigned subjects under this class is not accessible to teacher`
            );
          }

          return {
            sno: index + 1,
            class: item._id,
            english_subjects: english_subjects.length
              ? english_subjects.map((sub) => (
                  <AssignedSubject
                    key={sub._id}
                    staffId={staffId}
                    subject={sub}
                    removeSubject={removeSubjectFromSectionState}
                  />
                ))
              : "N/A",
            hindi_subjects: hindi_subjects.length
              ? hindi_subjects.map((sub) => (
                  <AssignedSubject
                    key={sub._id}
                    staffId={staffId}
                    subject={sub}
                    removeSubject={removeSubjectFromSectionState}
                  />
                ))
              : "N/A",
            ...info,
          };
        });
    }
    return arr;
  }, [teacherSchedule]);

  useEffect(() => {
    if (!modal) {
      setFormData({
        class: "",
        section: "",
        subject: "",
      });
      setSectionsId([]);
    }
  }, [modal]);

  const getSubjects = (subjects) => {
    return subjects
      .filter((subject) => subject.subjectId && !subject?.subjectId?.disabled)
      .map((sub) => ({
        subjectId: sub.subjectId._id,
        subject: `${sub.subject}  (${sub?.subjectId?.lang || "English"})`,
      }));
  };
  useEffect(() => {
    if (formData.class) {
      let temp = grades.find((item) => item.uniqueGrade === formData.class);
      setLabel(
        assignClassSubject(grades, temp.sections, getSubjects(temp.subjects))
      );
      setSections(temp.sections);
    }
  }, [formData.class]);
  const removeLangTag = (subjectName) => {
    if (!subjectName) return;
    return subjectName.split("(")[0].trim();
  };
  const handleCreate = () => {
    let data = {
      sections: sectionsId.map((item) => {
        return {
          sectionId: item,
          subjects: formData.subject //.map((sub) => removeLangTag(sub)),
        };
      }),
    };

    axios
      .put(subjectTeachers.assignSubjects(staffId), data, {
        headers: {
          token: `${readCookie("token")}`,
        },
      })
      .then((res) => {
        if (res.data.status === "success") {
          setRender(!render);
          if(res.data.errorLogs.length) {
           const errorMessage = res.data.errorLogs.join("\n");
           DisplaySnackbar(errorMessage, "warning");
          }else{
          DisplaySnackbar("Assigned Subject and Class", "success");
          }
          setModal(false);
        }
      })
      .catch((err) => {
        if (err.response) {
          DisplaySnackbar(err.response.data.message, "error");
        }
      });
  };

  return (
    <div>
      <CommonHeader>
        <div
          onClick={() => setModal(true)}
          style={{ display: "flex", cursor: "pointer", alignItems: "center" }}
        >
          <AddBoxOutlinedIcon style={{ marginRight: "7px" }} /> Add Subject
        </div>
        <Headerfeatures viewBy={false} />
      </CommonHeader>
      <Line />
      <TableComponent tabHeader={TeacherSchedule} tabContent={tabContent} />

      {modal && (
        <AddModalComponent
          handleMultiSelect={handleMultiSelect}
          handleCreate={handleCreate}
          formData={formData}
          setFormData={setFormData}
          setModal={setModal}
          label={label}
          headerText="Assign Class And Subject"
        />
      )}
    </div>
  );
}

export default TeachersSchedule;
